import { isInsuranceItem } from 'lib/checkout/checkoutUtils'
import { reselectShallowEqual } from 'lib/selector/selectorUtils'
import { createSelector } from 'reselect'

const getAllInsuranceBookingProtectionItems = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items): Array<App.Checkout.InsuranceItem> => items.filter(item => isInsuranceItem(item) && item.insuranceType === 'cfmr') as Array<App.Checkout.InsuranceItem>,
  reselectShallowEqual,
)

export default getAllInsuranceBookingProtectionItems
